import "./index.css"
import "./i18n.config"
import React from "react"
import { createRoot } from "react-dom/client"
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from "react-router"
import { DataContext, DomainContext, EthereumContext, LayoutContext, TransactionsContext } from "./context"
import { Loading } from "./components/Loading"
import { useChunkErrorHandler } from "./hooks/useChunkErrorHandler"
import { ErrorTemplate } from "./components/templates/Error"

import { Component as RootPage } from "./pages/Root"

import { ROUTES_IDS } from "./types/routes"

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route
        id={ROUTES_IDS.ROOT}
        element={<RootPage />}
        hydrateFallbackElement={<Loading />}
        errorElement={<ErrorTemplate />}
      >
        <Route path="/" lazy={async () => import("./pages/Migration")} />
      </Route>
    </>,
  ),
)

const App = () => {
  useChunkErrorHandler()

  return (
    <React.StrictMode>
      <DomainContext>
        <EthereumContext>
          <DataContext>
            <LayoutContext>
              <TransactionsContext>
                <RouterProvider router={router} />
              </TransactionsContext>
            </LayoutContext>
          </DataContext>
        </EthereumContext>
      </DomainContext>
    </React.StrictMode>
  )
}

const container = document.getElementById("root")!
const root = createRoot(container)
root.render(<App />)
